import { Typography } from '@mui/material';

export function AsteriskRequiredLabel() {
  return <Typography variant="body-xs">* Required fields</Typography>;
}
